// BiometricConfirmModal.js 생성
import NiceModal from "@ebay/nice-modal-react";
import ModalBase from "modals/base/ModalBase";
import { useRef } from "react";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import Dummy from "components/Dummy";
import HorizontalFlex from "layouts/flex/HorizontalFlex";

const BiometricConfirmModal = NiceModal.create(props => {
  const modal = useRef();

  return (
    <ModalBase
      slideUp
      ref={modal}
      width={"100%"}
      height={"auto"}
      withHeader={false}
      withFooter={false}
      withCloseButton={false}
      clickOutsideToClose={false}
      overflow={"visible"}
      borderRadius={"25px"}
      onClose={props.onClose}
    >
      <VerticalFlex gap={10} padding={30} backgroundColor={"white"}>
        <FlexChild>
          <Center>
            <P color={"black"} weight={700} size={20}>{props.title || "확인"}</P>
            <Dummy height={"20px"} />
            <P color={"#666666"} weight={500} size={16}>
              {props.content || "계속 진행하시겠습니까?"}
            </P>
          </Center>
        </FlexChild>
        <FlexChild>
          <HorizontalFlex gap={10}>
            <FlexChild>
              <CustomButton
                style={{
                  width: "100%",
                  backgroundColor: "var(--main-color)",
                  border: "none",
                  height: "48px",
                  fontWeight: 700,
                  color: "white"
                }}
                onClick={() => {
                  modal.current.close();
                  props.onConfirm && props.onConfirm();
                }}
                text={props.confirmText || "확인"}
              />
            </FlexChild>
            <FlexChild>
              <CustomButton
                style={{
                  width: "100%",
                  backgroundColor: "#f5f5f5",
                  border: "none",
                  height: "48px",
                  fontWeight: 700,
                  color: "#666666"
                }}
                onClick={() => {
                  modal.current.close();
                  props.onCancel && props.onCancel();
                }}
                text={props.cancelText || "취소"}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </ModalBase>
  );
});

export default BiometricConfirmModal;